import React, { useEffect, useState } from "react";
import {
  SmileDesignForm,
  SmileDesignProps,
} from "../../../types/UploadFieldsType";
import TextInput from "../formComp/TextInputOld";
import SelectInput from "../formComp/SelectInputOld";
import ToothSelector from "../formComp/ToothSelectorOld";

const SmileDesign: React.FC<SmileDesignProps> = ({ onChange }) => {
  const [form, setForm] = useState<SmileDesignForm>({
    toothNumbers: [],
    photoIncluded: "",
    biteOpening: "",
    teethExtractions: [],
    waxUp: "",
    proposedTreatmentPlan: "",
    otherConsiderations: "",
  });

  const handleToothClick = (
    type: "toothNumbers" | "teethExtractions",
    tooth: number
  ) => {
    const toothStr = tooth.toString();

    setForm((prev) => {
      const updated = prev[type].includes(toothStr)
        ? prev[type].filter((t) => t !== toothStr)
        : [...prev[type], toothStr];
      return { ...prev, [type]: updated };
    });
  };

  const handleChange = (field: keyof SmileDesignForm, value: string) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  useEffect(() => {
    onChange(form);
  }, [form, onChange]);

  return (
    <div className="w-full text-sm md:text-lg text-gray-900">
      <h2 className="font-bold mb-4 border-b-2 border-[#2fa9bf]">
        SMILE DESIGN
      </h2>

      <div className="w-[100%] md:w-[90%]">
        {/* Tooth Selection */}
        <div className="mb-2 flex">
          <label className="block mb-1 w-[35%]">
            Tooth #s<span className="text-red-500">*</span>
          </label>
          <div className="w-[65%]">
            <ToothSelector
              toothNumbers={form.toothNumbers}
              onToothClick={(tooth) => handleToothClick("toothNumbers", tooth)}
            />
          </div>
        </div>

        <SelectInput
          label="Photo Included"
          name="photoIncluded"
          value={form.photoIncluded}
          onChange={(e) => handleChange("photoIncluded", e.target.value)}
          options={[
            { value: "Yes", label: "Yes" },
            { value: "No", label: "No" },
          ]}
        />

        <TextInput
          optional
          label="Change In Vertical Dimension"
          name="biteOpening"
          value={form.biteOpening}
          onChange={(e) => handleChange("biteOpening", e.target.value)}
        />

        {/* Teeth to be Extracted */}
        <div className="mb-2 flex">
          <label className="block mb-1 w-[35%]">
            Teeth to be extracted (if any)
            <span className="text-gray-400 text-sm"> Optional</span>{" "}
          </label>
          <div className="w-[65%]">
            <ToothSelector
              toothNumbers={form.teethExtractions}
              onToothClick={(tooth) =>
                handleToothClick("teethExtractions", tooth)
              }
            />
          </div>
        </div>

        <SelectInput
          label="Wax Up"
          name="waxUp"
          value={form.waxUp}
          onChange={(e) => handleChange("waxUp", e.target.value)}
          options={[
            {
              value: "Additive wax up (no additional tooth prep)",
              label: "Additive wax up (no additional tooth prep)",
            },
            {
              value: "Restorative wax up (tooth prep to be done)",
              label: "Restorative wax up (tooth prep to be done)",
            },
          ]}
        />

        <SelectInput
          label="Proposed Treatment Plan"
          name="proposedTreatmentPlan"
          value={form.proposedTreatmentPlan}
          onChange={(e) =>
            handleChange("proposedTreatmentPlan", e.target.value)
          }
          options={[
            { value: "Crown and Bridge", label: "Crown and Bridge" },
            { value: "Veneer", label: "Veneer" },
            { value: "Implant", label: "Implant" },
            { value: "Composite Bonding", label: "Composite Bonding" },
          ]}
        />
        <TextInput
          optional
          label="Other Considerations"
          name="otherConsiderations"
          value={form.otherConsiderations}
          onChange={(e) => handleChange("otherConsiderations", e.target.value)}
        />
      </div>
    </div>
  );
};

export default SmileDesign;
